const RentalStatus = {
  EN_ATTENTE: 0, // Statut initial quand le client confirme la location
  ACTIF: 1, // Statut activé par admin/sales rep
  TERMINE: 2, // Statut terminé manuellement par admin/sales rep
  DATE_DEPASSEE: 3, // Statut automatique quand la date de fin est dépassée
  ATTENTE_FIN: 4, // Demande de fin de location en attente de validation
  A_LIVRER: 5, // Location validée, en attente de livraison
  A_RECUPERER: 6, // Location terminée, en attente de récupération de l'équipement
  EN_PREPARATION: 7, // Location en cours de préparation (entre validation et livraison)
};

export default RentalStatus;
